import { Component, input } from '@angular/core';
import { FieldTree, FormField } from '@angular/forms/signals';
import { MatInputModule } from '@angular/material/input';
import { FactorsUdr } from './factors-udr.model';


@Component({
  selector: 'app-factors-udr',
  imports: [FormField, MatInputModule],
  templateUrl: './factors-udr.component.html',
  styles: ``,
})
export class FactorsUdrComponent {

  readonly form = input.required<FieldTree<FactorsUdr>>();


  ngOnDestroy() {

    if (!this.form().sustainedRating().valid())
      this.form().sustainedRating().value.set(0);

    if (!this.form().referenceTemperature().valid())
      this.form().referenceTemperature().value.set(20);

    if (!this.form().parallelCables().valid())
      this.form().parallelCables().value.set(1);

  }



}
